const bill = [{
  desc: 'AI机器人计费-账户总览',
  options: {
    url: '/bill/account/overview',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: 'AI机器人计费-消耗明细',
  options: {
    url: '/bill/fee/detail',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: 'AI机器人计费-消耗趋势',
  options: {
    url: '/bill/fee/trend',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: 'AI机器人计费-账变流水',
  options: {
    url: '/bill/flow/list',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}]

export default bill



// WEBPACK FOOTER //
// ./src/api/bill.js